/* global MEDIA_ROOT */

import React from 'react';

const ArrowLeft = props => (
  <img {...props} src={`${MEDIA_ROOT}/icons/icn_arrowleft.svg`} alt="Arrow left" />
);

export default ArrowLeft;



// WEBPACK FOOTER //
// ./app/src/components/Iconography/components/ArrowLeft/index.jsx